import { Spin } from "antd";
import "./styles.scss";
export default function DBSpinner({ tip }) {
    return (
        <div className="db-spinner">
            <Spin tip={tip} />
        </div>
    );
}
